import {
  compose, lifecycle, withHandlers, withState, withStateHandlers,
} from 'recompose';
import { remove, reduce } from 'ramda';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';
import { closeModal, uploadTempFileRequest } from '../../../../state/ui/actions';
import { getModal, getTempFileUploadPending } from '../../../../state/ui/selectors';
import AttachFilesModal from './attachFilesModal';
import { projectsActions, projectsSelectors } from '../../../../state/projects';

const mapStateToProps = (state, { match: { params: { id } } }) => ({
  isOpen: getModal(state)('uploadFilesToProject'),
  isPending: getTempFileUploadPending(state),
  project: projectsSelectors.getProject(state)(id),
});

const mapDispatchToProps = ({
  onCloseModal: () => closeModal('uploadFilesToProject'),
  uploadTempFile: uploadTempFileRequest,
  updateProject: projectsActions.editProjectRequest,
});

const onChangeHandler = ({ setFilesList }) => (e) => {
  const filesList = Array.from(e.currentTarget.files);
  setFilesList(filesList);
};

const onUploadFilesHandler = ({
  filesList, uploadTempFile, setLoadingFiles, loadingFiles,
}) => () => {
  filesList.map((file) => {
    const formData = new FormData();
    formData.append('file', file);
    return uploadTempFile(formData, {
      callbacks: {
        success: ({ model }) => {
          setLoadingFiles(loadingFiles.concat(model));
        },
      },
    });
  });
  // const previewData = URL.createObjectURL(e.currentTarget.files[0]);
  // const formData = new FormData();
  // formData.append('file', e.currentTarget.files[0]);
};

const setLoadingFilesStateHandler = ({ loadingFiles }) => item => ({ loadingFiles: loadingFiles.concat(item) });

const onDeleteFileStateHandler = ({ loadingFiles }) => index => ({ loadingFiles: remove(index, 1, loadingFiles) });

const onSetTaskFilesHandler = ({
  loadingFiles, onCloseModal, setFilesList, onResetLoadingFiles, match: { params: { id } }, updateProject, project,
}) => (e) => {
  e.preventDefault();
  const filesList = reduce((accum, { id }) => accum.concat(id), [], loadingFiles);
  updateProject({
    ...project,
    id,
    files: filesList,
  }, { callbacks: { success: () => { onCloseModal(); setFilesList([]); onResetLoadingFiles([]); } }, isSoloProjectUpdate: true });
};

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withState('filesList', 'setFilesList', []),
  withStateHandlers(() => ({ loadingFiles: [] }), {
    onResetLoadingFiles: () => () => ({ loadingFiles: [] }),
    setLoadingFiles: setLoadingFilesStateHandler,
    onDeleteFile: onDeleteFileStateHandler,
  }),
  withHandlers({
    onChange: onChangeHandler,
    onUploadFiles: onUploadFilesHandler,
    onSetTaskFiles: onSetTaskFilesHandler,
  }),
  lifecycle({
    componentDidUpdate({ filesList }) {
      if (this.props.filesList !== filesList) {
        this.props.onUploadFiles();
      }
    },
  }),
);

export default enhance(AttachFilesModal);
